import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { usePlan } from './PlanContext';

export default function ServicioSuspendido({ children }) {
    const { activo, vencido, mensaje, loading } = usePlan();

    if (loading) return children;

    const suspendido = !activo;
    const vencidoBloqueante = vencido;

    if (!suspendido && !vencidoBloqueante) return children;

    return (
        <>
            {children}
            <div style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(20, 20, 30, 0.92)',
                zIndex: 99999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                backdropFilter: 'blur(6px)',
            }}>
                <div style={{
                    background: '#fff',
                    borderRadius: '14px',
                    padding: '32px 28px',
                    maxWidth: '480px',
                    width: '100%',
                    textAlign: 'center',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
                    border: '2px solid #dc3545',
                }}>
                    <div style={{
                        width: '72px',
                        height: '72px',
                        borderRadius: '50%',
                        background: '#fff5f5',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '16px',
                    }}>
                        <FontAwesomeIcon
                            icon={suspendido ? faLock : faExclamationTriangle}
                            style={{ fontSize: '32px', color: '#dc3545' }}
                        />
                    </div>

                    <h2 style={{ margin: '0 0 12px', color: '#212529', fontSize: '22px' }}>
                        {suspendido ? 'Servicio suspendido' : 'Suscripción vencida'}
                    </h2>

                    <p style={{ color: '#495057', fontSize: '15px', lineHeight: 1.5, margin: '0 0 20px' }}>
                        {mensaje || (suspendido
                            ? 'Tu acceso al sistema ha sido suspendido. Contactá al administrador para reactivarlo.'
                            : 'Tu suscripción venció. Renová para continuar usando el sistema.')}
                    </p>

                    <div style={{
                        background: '#fff8e1',
                        border: '1px solid #ffc107',
                        borderRadius: '8px',
                        padding: '10px 14px',
                        fontSize: '13px',
                        color: '#7a5b00',
                    }}>
                        Para regularizar tu situación contactanos por WhatsApp o email.
                    </div>
                </div>
            </div>
        </>
    );
}
